import React, { useState } from "react";
import { Form, Field } from "react-final-form";
import "./CaseFilter.scss";

const ProfilesFilter = (props) => {
  const [searchTerm, saveSearch] = useState("");
  const { toggleModal, searchResults, clearFilter, profile } = props;

  const submitFilterBy = (values) => {
    const searchValue = values.search.trim();
    //passes search value and profile type
    searchResults(values, profile);
    //closes search section
    toggleModal();
  };

  const handleClearing = (profileType) => {
    if (profileType == "foreign-worker") {
      //clears search parameter for foreign worker
      clearFilter("foreignWorker");
    }
    //closes search section
    toggleModal();
  };

  //sets search message
  const profileSearchMessage = (profile) => {
    let profileMessage;
    if (profile == "foreign-worker") {
      profileMessage =
        "Enter a Profile Name, Foreign Worker Name, Alien Registration Number, or Date of Birth.";
    }
    return profileMessage;
  };

  return (
    <Form
      onSubmit={submitFilterBy}
      initialValues={{ search: searchTerm }}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div className="caseFilter">
            <h2 className="caseFilter_h2_filterby">Filter by</h2>
            <div>
              <p>
                <b>Text</b>
                <br />
                <small>{profileSearchMessage(profile)}</small>
                <br />
              </p>
              <div className="usa-search usa-search--small desktop:grid-col-12 tablet:grid-col-12">
                <div role="search" className="cases-search">
                  <Field
                    type="search"
                    name="search"
                    component="input"
                    id="search-cases"
                    className="usa-input"
                    placeholder="Enter a search term"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="caseFilterButtons">
            <button
              className="caseFilterClearProfiles"
              type="button"
              onClick={() => handleClearing(profile)}
            >
              Clear Filter
            </button>

            <button className="caseFilterSubmitProfiles" type="submit">
              Apply
            </button>
          </div>
        </form>
      )}
    />
  );
};

export default ProfilesFilter;
